<template>
    <v-sheet>
        <div class="text-subtitle-1 font-weight-bold text-center">Operations</div>

        <v-data-table density="compact" color="primary" :fixed-header="true" :headers="tableHeaders" :items="operationsList">
            <template v-slot:headers="{ columns, isSorted, getSortIcon, toggleSort }">
                <tr>
                    <template v-for="column in columns" :key="column.key">
                        <th class="text-no-wrap bg-primary">
                            <span class="mr-2 cursor-pointer" @click="() => toggleSort(column)">{{ column.title }}</span>
                            <template v-if="isSorted(column)">
                                <v-icon :icon="getSortIcon(column)" size="0.875rem"></v-icon>
                            </template>
                        </th>
                    </template>
                </tr>
            </template>
            <template v-slot:item.PartNum="{ value }">
                <div class="text-no-wrap">{{value}}</div>
            </template>
            <template v-slot:item.StartDate="{ value }">
                <div class="text-no-wrap">{{value}}</div>
            </template>
            <template v-slot:item.DueDate="{ value }">
                <div class="text-no-wrap">{{value}}</div>
            </template>
            <template v-slot:item.OpDesc="{ value }">
                <div class="text-truncate" style="max-width: 200px;">
                    {{ value }}
                    <v-tooltip
                        activator="parent"
                        location="bottom"
                    >
                        {{ value }}
                    </v-tooltip>
                </div>
            </template>
        </v-data-table>
    </v-sheet>
</template>

<script>
import {useJobEntryStore} from "../../../../../../stores/ProjectManagement/JobEntry";
import {computed, ref} from "vue";

export default {
    name: "ListWindow",
    setup() {
        const jobEntryStore = useJobEntryStore();
        const job = computed(() => jobEntryStore.job);

        const tableHeaders = ref([
            { title: 'Opr.', key: 'OprSeq' },
            { title: 'Operation Description', key: 'OpDesc' },
            { title: 'Operation', key: 'OpCode' },
            { title: 'ProductionQty', key: 'RunQty' },
            { title: 'Qty/Parent', key: 'QtyPer' },
            { title: 'Est. Setup Hours', key: 'EstSetHours' },
            { title: 'Completed', key: 'OpComplete' },
            { title: 'Est Prod Hours', key: 'EstProdHours' },
            { title: 'Final Operation', key: '???' }, //TODO: find out where is this stored
            { title: 'Subcontract', key: 'SubContract' },
            { title: 'Labor Entry', key: 'LaborEntryMethod' },
            { title: 'Added Operation', key: 'AddedOper' },
            { title: 'Start Date', key: 'StartDate' },
            { title: 'Due Date', key: 'DueDate' },
            { title: 'Machines', key: 'Machines' },
            { title: 'AutoReceive', key: '???' }, //TODO: find out where is this stored
            { title: 'FSJobStatus', key: 'FSJobStatus' },
            { title: 'Instructions', key: 'Instructions' },
            { title: 'ProdUOM', key: 'ProdUOM' },
            { title: 'GeneralPlanInfo', key: 'GeneralPlanInfo' },
            { title: 'EstStdDescription', key: 'EstStdDescription' },
            { title: 'JDFOpCompleted', key: 'JDFOpCompleted' },
            { title: 'RemovedFromPlan', key: 'RemovedfromPlan' },
            { title: 'EstStdType', key: 'EstStdType' },
            { title: 'Machine MES', key: 'ExternalMES' },
            { title: 'PctReg', key: 'PctReg' },
            { title: 'SetupMaterial', key: 'SetupMaterial' },
            { title: 'MaterialColorRating', key: 'MaterialColorRating' },
            { title: 'MiscAmt', key: 'MiscAmt' },
            { title: 'MiscInfo1', key: 'MiscInfo1' },
            { title: 'MiscInfo2', key: 'MiscInfo2' },
            { title: 'SetupURL', key: 'SetupURL' },
            { title: 'ExpPctUp', key: 'ExpPctUp' },
            { title: 'ExpCycTm', key: 'ExpCycTm' },
            { title: 'ExpGood', key: 'ExpGood' },
            { title: 'NonProdLimit', key: 'NonProdLimit' },
            { title: 'AutoSpcPeriod', key: 'AutoSpcPeriod' },
            { title: 'PartQualEnabled', key: 'PartQualEnable' },
            { title: 'AutoSpcSubgroup', key: 'AutoSpcSubgroup' },
            { title: 'MobileOperation', key: 'MobileOperation' },
            { title: 'ReWork', key: 'ReWork' },
            { title: 'RequestMove', key: 'RequestMove' },
            { title: 'UserMapData', key: 'UserMapData' },
            { title: 'Rough Cut Scheduled Operation', key: 'RoughCutSched' },
            { title: 'Schedule Comment', key: 'SchedComment' },
            { title: 'Contract ID', key: 'ContractID' },
            { title: 'PrinterID', key: 'PrinterID' },
            { title: 'LastPrintedDate', key: 'LastPrintedDate' },
            { title: 'Machine MES Sync Required', key: 'ExternalMESSyncRequired' },
            { title: 'Machine MES Last Sync', key: 'ExternalMESLastSync' },
            { title: 'LastPCIDPrinted', key: 'LastPCIDPrinted' },
            { title: 'Pieces per Cycle', key: 'QtyPerCycle' },
            { title: 'Package Code', key: '???' }, //TODO: find out where is this stored
            { title: 'Assembly Weight', key: 'Weight' },
            { title: 'Weight UOM', key: 'WeightUOM' },
            { title: 'PrjRoleList', key: 'PrjRoleList' },
            { title: 'TearDwnEndHour', key: 'TearDwnEndHour' },
            { title: 'WITearDwnEndHour', key: 'WITearDwnEndDate' },
            { title: 'Allow use all Role', key: 'UseAllRoles' },
            { title: 'Part', key: 'PartNum' },
            { title: 'Serial Number', key: 'SerialNumber' },
            { title: 'Send Ahead Type', key: 'SendAheadType' },
            { title: 'Serial Numbers Required From This Operation', key: 'SNRequiredOpr' },
            { title: 'Serial Numbers Required When Shipping', key: 'SNRequiredSubConShip' },
            { title: 'RefreshResources', key: '???' }, //TODO: find out where is this stored
            { title: 'StdFormatDescription', key: 'StdFormat' },
            { title: 'StdBasisDescription', key: 'StdBasis' },
            { title: 'PrimaryProdOpDtlDesc', key: 'PrimaryProdOpDtl' },
            { title: 'Act Qty Scrap', key: 'EstScrap' },
            { title: 'Currency Code', key: 'CurrentPkgCode' },
            { title: 'IUM', key: 'IUM' },
            { title: 'UOM', key: '???' }, //TODO: find out where is this stored
            { title: 'Printed_c', key: '???' }, //TODO: find out where is this stored
            { title: 'LastPrinted_c', key: '???' }, //TODO: find out where is this stored
            { title: 'Last Modified', key: '???' }, //TODO: find out where is this stored
            { title: 'Printed Part', key: '???' }, //TODO: find out where is this stored
            { title: 'Printed Quantity', key: '???' }, //TODO: find out where is this stored
            { title: 'Bom', key: '???' }, //TODO: find out where is this stored
            { title: 'ProdNote_c', key: '???' }, //TODO: find out where is this stored
        ])

        const operationsList = computed(() => jobEntryStore.currentAssemblyOperations ?? []);

        return {
            job,
            tableHeaders,
            operationsList,
        }
    }
}
</script>

<style scoped>

</style>
